/**
 * Client-only: capture landing-page UTM query params into sessionStorage.
 * Independent of GA/Pendo enablement — used for community traffic attribution.
 *
 * Capture runs once on plugin init (current route). Mid-session SPA navigations
 * do not re-capture: in-app routes typically drop UTMs, and a full page load of a
 * UTM deep link re-runs this plugin.
 */

import { defineNuxtPlugin } from 'nuxt/app'
import { useRouter } from 'nuxt/app'

import { captureCommunityUtmFromQuery } from '../utils/utm-session'

export default defineNuxtPlugin(() => {
  const router = useRouter()

  captureCommunityUtmFromQuery(router.currentRoute.value.query as Record<string, string | string[] | null | undefined>)
})
